// Assign Items To Test → item picker popup: row shape and the pure rules behind it,
// kept apart from AssignItemsDialog.tsx so the component file exports only the
// component (fast refresh) and the rules are testable on their own.

/** One Item in the popup (GET /inventory-items/test-method/{id}/popup-items).
 *  `description` is the item's Specification — the legacy popup's "Description". */
export interface AssignItemRow {
  oid: string;
  item: string;
  description: string;
  vendor: string;
  catalogNo: string;
  isLinked: boolean;
}

/** The popup's Search box: matches what the popup shows, ignoring case; blank shows all. */
export function filterItems(rows: AssignItemRow[], search: string): AssignItemRow[] {
  const q = search.trim().toLowerCase();
  if (!q) return rows;
  return rows.filter((r) => `${r.item} ${r.description} ${r.vendor} ${r.catalogNo}`.toLowerCase().includes(q));
}

/** True when the ticked set is exactly the saved one — nothing to save, nothing to lose. */
export function sameSelection<K>(a: ReadonlySet<K>, b: ReadonlySet<K>): boolean {
  if (a.size !== b.size) return false;
  for (const k of a) if (!b.has(k)) return false;
  return true;
}
